import { Component, OnInit } from "@angular/core";
import { LoaderService } from "../../../core/services/loader.service";
import { Spinkit } from "ng-http-loader";

@Component({
  selector: "app-loader",
  templateUrl: "./loader.component.html",
  styleUrls: ["./loader.component.css"],
})
export class LoaderComponent implements OnInit {
  loading: boolean;
  public spinkit = Spinkit;

  constructor(private loaderService: LoaderService) {
    this.loaderService.isLoading.subscribe((v) => {
      this.loading = v;
    });
  }
  ngOnInit() {}
}
